<template>
  <div id="app">
    <NavPanel />
    <AIImageEditor />
    <TutorialSection />
    <ShowcaseSection />
  </div>
</template>

<script>
  /* eslint-disable */
import NavPanel from './components/NavPanel.vue'
import AIImageEditor from './components/AIImageEditor.vue'
import TutorialSection from './components/TutorialSection.vue'
import ShowcaseSection from './components/ShowcaseSection.vue'

export default {
  name: 'App',
  components: {
    NavPanel,
    AIImageEditor,
    TutorialSection,
    ShowcaseSection
  }
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
